import { Component } from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';

@Component({
  selector: 'app-homonym-word-play-btn',
  styleUrls: ['./homonym-word-play-btn.component.scss'],
  template: `
    <button type="button"
            class="play-btn {{ on ? 'on' : '' }}"
            *ngIf="word && word.wordVoice"
            (click)="playSound($event)"></button>
  `,
})
export class HomonymWordPlayBtnComponent extends WordPlayBtnComponent {

  constructor(
    protected voice: VoiceService,
  ) {
    super(voice);
  }

}
